import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from '@/components/ui/table'

const nameWidths = ['w-48', 'w-36', 'w-56', 'w-32']

const ProjectsTableSkeleton: React.FC = () => {
  return (
    <div>
      <div className="py-2 flex items-center justify-end">
        <Skeleton className="h-8 w-40" />
      </div>

      <div className="rounded-md border border-border overflow-hidden bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>
                <Skeleton className="h-4 w-16" />
              </TableHead>
              <TableHead className="w-[50px]" />
            </TableRow>
          </TableHeader>
          <TableBody>
            {nameWidths.map((width, i) => (
              <TableRow key={i}>
                <TableCell>
                  <Skeleton className={`h-4 ${width}`} />
                </TableCell>
                <TableCell>
                  <Skeleton className="h-4 w-4" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <div className="flex items-center justify-end py-2 px-1">
        <Skeleton className="h-3 w-16" />
      </div>
    </div>
  )
}

export default ProjectsTableSkeleton
